// import { ChainType, Web3Kit } from "@web3kit/";

import { StoreOrder } from "@/store/payment";

import { getTrustWalletInjectedProvider, TronLink, useWeb3Provider } from "./useContract";

class Disconnect {
    private order: StoreOrder
    private setLoading: (boolean: boolean) => void
    message = {
        code: -1995,
        message: "Insufficient balance"
    }
    errorMessage: {
        code: -2000,
        message: "network error"
    }

    constructor(
        order: StoreOrder,
        setLoading: (boolean: boolean) => void
    ) {
        this.order = order
        this.setLoading = setLoading
    }

    async metamask() {
        return new Promise(async (resolve, reject) => {
            try {
                this.setLoading(true)
                const { ethereumProvider } = await useWeb3Provider()
                
                if (!ethereumProvider) {
                    throw new Error("Metamask extension is not installed!")
                }

                await ethereumProvider.request({ 
                  method: "wallet_revokePermissions",
                  params: [{ eth_accounts: {} }]
                })
                resolve(true)
            } catch(err) {
                reject(err)
            }
        })
    }

    async broearnWallet() {
        return new Promise(async (resolve, reject) => {
            try {
                this.setLoading(true)
                switch (this.order.chain) {
                    case "PUT":
                        const session = localStorage.getItem("bw_session");
                        if (session && !!window.bw) {
                            await window.bw.put.disconnect({ session: Number(session) });                            
                            localStorage.removeItem("bw_session");

                            resolve(true)
                        }
                        break
                    case "Tron":
                        console.log("should disconnect tron")
                        break
                    default:
                        await window.bw?.eth.request({ 
                            method: "wallet_revokePermissions",
                            params: [{ eth_accounts: {} }]
                        })
                        resolve(true)
                        break
                }
            } catch(err) {
                reject(err)
            }
        })
    }

    async tronLink(provider?: TronLink | null) {
        return new Promise(async (resolve, reject) => {
            try {
                const tronLink = provider ?? TronLink()

                if (!tronLink) {
                    reject("tronLink not ready!")
                    return
                }

                this.setLoading(true)
                await tronLink.request({
                    method: 'wallet_revokePermissions',
                    params: [{ eth_accounts: {} }]
                })

                resolve(true)
            } catch(error) {
                reject(error)
            }
        })
    }

    async okx() {
        return new Promise(async (resolve, reject) => {
            try {
                if (!window.okxwallet) {
                   reject("OKX wallet extension is not installed!")
                   return
                }

                this.setLoading(true)    
                
                if (this.order.chain === "Tron") {
                    let tronLink = window.okxwallet?.tronLink
                    console.log("pre connect tron account----->")
    
                    this.tronLink(tronLink as any).then(resolve).catch(reject)
                    return
                }
    
                
                await window.okxwallet.request({ 
                    method: "wallet_revokePermissions",
                    params: [{ eth_accounts: {} }]
                });
                resolve(true)
            } catch (err) {
                reject(err)
            }
        })
    }

    async trust() {
        return new Promise(async (resolve, reject) => {
            try {
                this.setLoading(true)
                const trustWallet: any = await getTrustWalletInjectedProvider()
                
                if (!trustWallet) {
                    reject("Trust wallet extension is not installed!")
                    return
                }

                await trustWallet.request({ 
                  method: "wallet_revokePermissions",
                  params: [{ eth_accounts: {} }]
                })
                resolve(true)
            } catch(err) {
                reject(err)
            }
        })
    }

    async walletconnect() {

    }
}

export { Disconnect };
export default Disconnect
